import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { isEqual } from 'lodash';

@Component({
  selector: 'payment-list-filter',
  templateUrl: './payment-list-filter.component.html',
  styleUrls: ['./payment-list-filter.component.scss'],
  standalone: false,
})
export class PaymentListFilterComponent implements OnInit {
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';
  private pageFilter: app.models.GetPagedPaymentsPageFilterModel;
  private initialFilterState: app.models.GetPagedPaymentsPageFilterModel;
  public startDate: Date;
  public endDate: Date;

  public constructor(private _activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.pageFilter.startDate) {
      this.startDate = new Date(this.pageFilter.startDate);
    }

    if (this.pageFilter.endDate) {
      this.endDate = new Date(this.pageFilter.endDate);
    }
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.pageFilter.startDate = null;
    this.pageFilter.endDate = null;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    if (this.startDate) this.pageFilter.startDate = this.startDate;
    if (this.endDate) this.pageFilter.endDate = this.endDate;
    let count = 0;
    if (this.pageFilter.startDate != null) count++;
    if (this.pageFilter.endDate != null) count++;

    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : count);
  }

  disableStartDates = (date: Date): boolean => {
    if (this.pageFilter.endDate) {
      return date > this.pageFilter.endDate;
    }
    return false;
  };

  disableEndDates = (date: Date): boolean => {
    if (this.pageFilter.startDate) {
      return date < this.pageFilter.startDate;
    }
    return false;
  };
}
